import { DotGroup } from 'pure-react-carousel';
import styled from 'styled-components';
import { getPaletteColor } from 'pcln-design-system';
var StyledDotGroup = styled(DotGroup).withConfig({
  displayName: "Dotsstyles__StyledDotGroup",
  componentId: "sc-18a5mqc-0"
})(["display:flex;max-width:320px;min-width:240px;& > button{flex:1;height:5px;border-width:0px 1px 0px 1px;border-style:solid;border-color:", ";background:", ";margin:0px;border:0px;padding:0px;border-radius:0px;}&>button:hover{border-color:", ";background:", ";}& > button.carousel__dot--selected{background:", ";border-color:", ";}& > button.carousel__dot--selected:hover{background:", ";border-color:", ";}"], function (props) {
  return getPaletteColor('border.tint')(props);
}, function (props) {
  return getPaletteColor('border.tint')(props);
}, function (props) {
  return getPaletteColor('background.lightest')(props);
}, function (props) {
  return getPaletteColor('primary.base')(props);
}, function (props) {
  return getPaletteColor('border.shade')(props);
}, function (props) {
  return getPaletteColor('border.shade')(props);
}, function (props) {
  return getPaletteColor('border.shade')(props);
}, function (props) {
  return getPaletteColor('border.shade')(props);
});
export { StyledDotGroup };